import { ZERO_DISTANCE } from "@pdfking/math/constants"

import type { ComponentSchema, ImpositionSchema } from "#internal"
import type { ImpositionObject } from "#internal"

import { BuildGrowLayout } from "../../common/grow/BuildGrowLayout"
import { ApplyOrientation } from "../utils/ApplyOrientation"
import { ComponentSecurity } from "./ComponentSecurity"

/**
 * Mirrors Python `_get_size_for_component` → `grow.grow_canvas` →
 * `grow_with_dimensions` (concrete.py:94-97, generic.py:41-102): the page the
 * way round the orientation wants it, the security margins as they are given
 * — top, right, bottom, left of the page — the spine and material thickness
 * read off the input, all handed to the grow.
 */
export const BuildComponentGrow = (
  input: ImpositionSchema,
  component: ComponentSchema,
  print_front: boolean,
  print_rear: boolean
): ImpositionObject => {
  const canvas = ApplyOrientation(input.size, input.orientation_kind)
  const grow = component.grow_kind
  const sheet_depth = component.sheet_depth ?? ZERO_DISTANCE

  return BuildGrowLayout({
    canvas,
    orientation: input.orientation_kind,
    grow,
    dimensions: { depth: input.size_depth, sheet_depth },
    padding: component.padding,
    security: ComponentSecurity(component),
    title: component.label || undefined,
    print_front,
    print_rear,
    box_opts: { ...canvas, depth: input.size_depth, sheet_depth },
  })
}
